/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitTag,
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';
import {
    PressKitThumbnailUrls,
    PressKitThumbnailUrlsFromJSON,
    PressKitThumbnailUrlsFromJSONTyped,
    PressKitThumbnailUrlsToJSON,
} from './PressKitThumbnailUrls';

/**
 * プレスキットプロフィールの詳細
 * @export
 * @interface PressKitProfileDetail
 */
export interface PressKitProfileDetail {
    /**
     * PressKit Image UUID(v4)
     * @type {string}
     * @memberof PressKitProfileDetail
     */
    id: string;
    /**
     * ファイル拡張子（原則英語小文字）
     * @type {string}
     * @memberof PressKitProfileDetail
     */
    extension: PressKitProfileDetailExtensionEnum;
    /**
     * ファイルのサイズ（単位はbytes）
     * @type {number}
     * @memberof PressKitProfileDetail
     */
    fileSize: number;
    /**
     * 企業が登録したプロフィールの役職
     * @type {string}
     * @memberof PressKitProfileDetail
     */
    title: string;
    /**
     * 企業が登録したプロフィールの名前
     * @type {string}
     * @memberof PressKitProfileDetail
     */
    name: string;
    /**
     * 企業が登録したプロフィールの名前のよみがな（発音)
     * @type {string}
     * @memberof PressKitProfileDetail
     */
    nameKana: string;
    /**
     * 企業が登録したプロフィール文
     * @type {string}
     * @memberof PressKitProfileDetail
     */
    description: string;
    /**
     * 
     * @type {PressKitThumbnailUrls}
     * @memberof PressKitProfileDetail
     */
    thumbnailUrls: PressKitThumbnailUrls;
    /**
     * 画像のダウンロード用URL。別ドメイン。
     * @type {string}
     * @memberof PressKitProfileDetail
     */
    downloadUrl: string;
    /**
     * ラスター画像の幅。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PressKitProfileDetail
     */
    imageWidth: number;
    /**
     * ラスター画像の高さ。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PressKitProfileDetail
     */
    imageHeight: number;
    /**
     * 企業が設定しているタグの一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitProfileDetail
     */
    readonly tags: Array<PressKitTag>;
}

/**
* @export
* @enum {string}
*/
export enum PressKitProfileDetailExtensionEnum {
    Jpg = 'jpg',
    Png = 'png'
}

export function PressKitProfileDetailFromJSON(json: any): PressKitProfileDetail {
    return PressKitProfileDetailFromJSONTyped(json, false);
}

export function PressKitProfileDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitProfileDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'extension': json['extension'],
        'fileSize': json['file_size'],
        'title': json['title'],
        'name': json['name'],
        'nameKana': json['name_kana'],
        'description': json['description'],
        'thumbnailUrls': PressKitThumbnailUrlsFromJSON(json['thumbnail_urls']),
        'downloadUrl': json['download_url'],
        'imageWidth': json['image_width'],
        'imageHeight': json['image_height'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitProfileDetailToJSON(value?: PressKitProfileDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'extension': value.extension,
        'file_size': value.fileSize,
        'title': value.title,
        'name': value.name,
        'name_kana': value.nameKana,
        'description': value.description,
        'thumbnail_urls': PressKitThumbnailUrlsToJSON(value.thumbnailUrls),
        'download_url': value.downloadUrl,
        'image_width': value.imageWidth,
        'image_height': value.imageHeight,
    };
}

